import { AbstractTimeBasedEntity } from "./AbstractTimeBasedEntity";
import { DicCompetenceType } from "./tsadv$DicCompetenceType";
import { Scale } from "./tsadv$Scale";
import { CompetenceGroup } from "./tsadv$CompetenceGroup";
import { FileDescriptor } from "./sys$FileDescriptor";
import { DicCompany } from "./base_DicCompany";
export class Competence extends AbstractTimeBasedEntity {
  static NAME = "tsadv$Competence";
  competenceName?: string | null;
  competenceNameLang1?: string | null;
  competenceNameLang2?: string | null;
  competenceNameLang3?: string | null;
  competenceNameLang4?: string | null;
  competenceNameLang5?: string | null;
  competeceType?: DicCompetenceType | null;
  scale?: Scale | null;
  group?: CompetenceGroup | null;
  attachment?: FileDescriptor | null;
  isRcAvailable?: boolean | null;
  company?: DicCompany | null;
}
export type CompetenceViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "competence-for-competence-element-position-edit"
  | "competence-for-competence-element-position-edit"
  | "competence-view"
  | "competence.edit";
export type CompetenceView<V extends CompetenceViewName> = V extends "_base"
  ? Pick<
      Competence,
      | "id"
      | "competenceName"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "startDate"
      | "endDate"
      | "scale"
      | "isRcAvailable"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "writeHistory"
    >
  : V extends "_local"
  ? Pick<
      Competence,
      | "id"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "isRcAvailable"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "startDate"
      | "endDate"
      | "writeHistory"
    >
  : V extends "_minimal"
  ? Pick<
      Competence,
      | "id"
      | "competenceName"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "startDate"
      | "endDate"
      | "scale"
    >
  : V extends "competence-for-competence-element-position-edit"
  ? Pick<
      Competence,
      | "id"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "isRcAvailable"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "startDate"
      | "endDate"
      | "writeHistory"
      | "competenceName"
      | "competeceType"
      | "scale"
      | "group"
    >
  : V extends "competence-for-competence-element-position-edit"
  ? Pick<
      Competence,
      | "id"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "isRcAvailable"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "startDate"
      | "endDate"
      | "writeHistory"
      | "competenceName"
      | "competeceType"
      | "scale"
      | "group"
    >
  : V extends "competence-view"
  ? Pick<
      Competence,
      | "id"
      | "competenceName"
      | "scale"
      | "attachment"
      | "isRcAvailable"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "competeceType"
      | "company"
    >
  : V extends "competence.edit"
  ? Pick<
      Competence,
      | "id"
      | "competenceNameLang1"
      | "competenceNameLang2"
      | "competenceNameLang3"
      | "competenceNameLang4"
      | "competenceNameLang5"
      | "isRcAvailable"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "startDate"
      | "endDate"
      | "writeHistory"
      | "scale"
      | "group"
      | "attachment"
      | "competenceName"
      | "competeceType"
      | "company"
    >
  : never;
